import { apiRequest } from './http';
import { getDeviceMeta } from '../helpers/device';
import type { ApiEnvelope, PairInitiateResponse, PairStatusResponse } from '../types/api';

// POST pairing/initiate -> pairing code + QR + websocket channel.
export async function pairInitiate(): Promise<PairInitiateResponse> {
  const res = await apiRequest<ApiEnvelope<PairInitiateResponse>>('pairing/initiate', {
    method: 'POST',
    body: await getDeviceMeta(),
    auth: false,
  });
  if (!res.data) throw new Error(res.message ?? 'Pairing initiation failed.');
  return res.data;
}

// GET pairing/status?uuid= -> { paired, code } until { token, device_id }.
export async function pairStatus(uuid: string): Promise<PairStatusResponse> {
  const res = await apiRequest<ApiEnvelope<PairStatusResponse>>(
    `pairing/status?uuid=${encodeURIComponent(uuid)}`,
    { auth: false },
  );
  if (!res.data) throw new Error(res.message ?? 'Pairing status failed.');
  return res.data;
}
